<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-large-plus"
    title="インターネットサイト設定(Type4)"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{ addressList: addressList, fqdnList: fqdnList }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-tabs v-model="tabValue" grow hide-slider>
                <v-tab text="アドレス" value="address"></v-tab>
                <v-tab text="FQDN" value="fqdn"></v-tab>
              </v-tabs>
              <v-tabs-window v-model="tabValue">
                <v-tabs-window-item value="address">
                  <v-row>
                    <v-col cols="4">
                      <app-badge
                        item="アドレス名"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: 20,
                          })
                        "
                        :isRequired="false"
                        placement="end"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-badge
                        item="アドレス"
                        :isRequired="
                          hasInputIpAddressName || addressList.length !== 1
                        "
                        :msg="
                          $filter.message(
                            'info_cidr_ip_address_of_network_address',
                            {
                              ipaddress1: '61.200.163.0/24',
                              genre: 'アドレス',
                              subnet1: '1',
                              subnet2: '30',
                              ipaddress2: '61.200.163.35/32',
                            }
                          )
                        "
                        placement="end"
                      />
                    </v-col>
                    <v-col>
                      <app-badge
                        item="ポリシー使用有無"
                        :isRequired="false"
                        :isInfo="false"
                      />
                    </v-col>
                  </v-row>
                  <validation-array
                    name="addressList"
                    v-slot="{ fields, push, remove }"
                  >
                    <template v-for="(item, index) in fields" :key="item.key">
                      <v-row>
                        <v-col cols="4">
                          <validation-provider
                            :name="`ipAddressName_${item.key}`"
                            v-model="addressList[index].ipAddressName"
                            label="アドレス名"
                            :rules="{
                              max: { length: 20 },
                              duplicate: { list: existsAddressNm(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :disabled="
                                addressList[index].isPolicyInUse ||
                                (isPolicy &&
                                  addressList[index].ipAddressId !== '')
                              "
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="4">
                          <validation-provider
                            :name="`ipAddress_${item.key}`"
                            v-model="addressList[index].ipAddress"
                            label="アドレス"
                            :rules="{
                              required:
                                !!addressList[index].ipAddressName ||
                                addressList.length !== 1,
                              is_ip_subnet: {
                                min: 1,
                                max: 32,
                                exclude: [31],
                              },
                              is_not_current_ip: true,
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              is_network_address: true,
                              duplicate: { list: existsAddress(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :disabled="
                                addressList[index].isPolicyInUse ||
                                (isPolicy &&
                                  addressList[index].ipAddressId !== '')
                              "
                              :placeholder="
                                addressList[index].isPolicyInUse
                                  ? null
                                  : $filter.message(
                                      'placeholder_global_ip_address_with_subnet32'
                                    )
                              "
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="2">
                          <div class="ml-5 mt-2">
                            <span>{{
                              $filter.enumTo(
                                addressList[index].isPolicyInUse,
                                "isPolicyInUse"
                              )
                            }}</span>
                          </div>
                        </v-col>
                        <v-col
                          cols="2"
                          class="text-end"
                          v-if="
                            (!addressList[index].isPolicyInUse && !isPolicy) ||
                            (addressList[index].ipAddressId === '' && isPolicy)
                          "
                        >
                          <v-btn
                            icon="$mdiMinus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm"
                            @click="removeIPAddress(index, remove)"
                          />
                        </v-col>
                      </v-row>
                    </template>

                    <v-row justify="end" class="text-end">
                      <v-col cols="2">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="addIPAddress(push)"
                        />
                      </v-col>
                    </v-row>
                  </validation-array>
                </v-tabs-window-item>
                <v-tabs-window-item value="fqdn">
                  <v-row>
                    <v-col cols="4">
                      <app-badge
                        item="FQDN名"
                        :isRequired="false"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: 20,
                          })
                        "
                        placement="end"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-badge
                        item="FQDN"
                        :isRequired="hasInputFqdnName || fqdnList.length !== 1"
                        :msg="$filter.message('info_fqdn')"
                        placement="end"
                      />
                    </v-col>
                    <v-col>
                      <app-badge
                        item="ポリシー使用有無"
                        :isRequired="false"
                        :isInfo="false"
                      />
                    </v-col>
                  </v-row>
                  <validation-array
                    name="fqdnList"
                    v-slot="{ fields, push, remove }"
                  >
                    <template v-for="(item, index) in fields" :key="item.key">
                      <v-row>
                        <v-col cols="4">
                          <validation-provider
                            :name="`fqdnName_${item.key}`"
                            v-model="fqdnList[index].fqdnName"
                            label="FQDN名"
                            :rules="{
                              max: { length: 20 },
                              duplicate: { list: existsFqdnNm(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                              :disabled="
                                fqdnList[index].isPolicyInUse ||
                                (isPolicy && fqdnList[index].fqdnId !== '')
                              "
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="4">
                          <validation-provider
                            :name="`fqdn_${item.key}`"
                            v-model="fqdnList[index].fqdn"
                            label="FQDN"
                            :rules="{
                              required:
                                !!fqdnList[index].fqdnName ||
                                fqdnList.length !== 1,
                              is_fqdn: true,
                              is_not_both: { notBoth: ['-', '.'] },
                              min: { length: 3 },
                              max: { length: 255 },
                              duplicate: { list: existsFqdn(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                              :disabled="
                                fqdnList[index].isPolicyInUse ||
                                (isPolicy && fqdnList[index].fqdnId !== '')
                              "
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="2">
                          <div class="ml-5 mt-2">
                            <span>{{
                              $filter.enumTo(
                                fqdnList[index].isPolicyInUse,
                                "isPolicyInUse"
                              )
                            }}</span>
                          </div>
                        </v-col>
                        <v-col
                          cols="2"
                          class="text-end"
                          v-if="
                            (!fqdnList[index].isPolicyInUse && !isPolicy) ||
                            (fqdnList[index].fqdnId === '' && isPolicy)
                          "
                        >
                          <v-btn
                            icon="$mdiMinus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm"
                            @click="removeFqdn(index, remove)"
                          />
                        </v-col>
                      </v-row>
                    </template>

                    <v-row justify="end">
                      <v-col cols="2" class="text-end">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="addFqdn(push)"
                        />
                      </v-col>
                    </v-row>
                  </validation-array>
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">変更</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel">
                  キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  PostType4InternetSite,
  Type4InternetAddress,
  Type4InternetFQDN,
  Type4InternetSite,
} from "@/apis/Type4SiteApi";
import type { ApplianceInfo } from "@/apis/ContractApi";
import cloneDeep from "lodash/cloneDeep";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "Type4InternetSiteModify",
  props: {
    internetSite: {
      type: Object as PropType<Type4InternetSite>,
      required: true,
    },
    type4Id: {
      type: String as PropType<ApplianceInfo["type4Id"]>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "address",
      addressList:
        this.internetSite.addressList.length === 0
          ? [
              {
                ipAddressId: "",
                ipAddressName: "",
                ipAddress: "",
                isPolicyInUse: false,
              },
            ]
          : (cloneDeep(
              this.internetSite.addressList
            ) as Type4InternetAddress[]),
      fqdnList:
        this.internetSite.fqdnList.length === 0
          ? [
              {
                fqdnId: "",
                fqdnName: "",
                fqdn: "",
                isPolicyInUse: false,
              },
            ]
          : (cloneDeep(this.internetSite.fqdnList) as Type4InternetFQDN[]),
    };
  },

  computed: {
    /** 既存のIPアドレス名 */
    existsAddressNm() {
      // 既存のアドレス名リストに同じIPアドレス名が存在した場合はエラーとする
      return (index: number) => {
        return this.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddressName);
      };
    },
    /** 既存のIPアドレス */
    existsAddress() {
      // 既存のアドレスリストに同じIPアドレスが存在した場合はエラーとする
      return (index: number) => {
        return this.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddress);
      };
    },
    /** 既存のFQDN名 */
    existsFqdnNm() {
      // 既存のFQDN名リストに同じFQDN名が存在した場合はエラーとする
      return (index: number) => {
        return this.fqdnList
          .filter((_, num) => num !== index)
          .map((v) => v.fqdnName);
      };
    },
    /** 既存のFQDN */
    existsFqdn() {
      // 既存のFQDNリストに同じFQDNが存在した場合はエラーとする
      return (index: number) => {
        return this.fqdnList
          .filter((_, num) => num !== index)
          .map((v) => v.fqdn);
      };
    },
    /** 遷移元がポリシー設定の場合は,true */
    isPolicy(): boolean {
      return this.$route.path === "/network/contract";
    },
    /** アドレス名入力済みの場合は,true */
    hasInputIpAddressName(): boolean {
      return this.addressList.some((v) => v.ipAddressName);
    },
    /** FQDN名入力済みの場合は,true */
    hasInputFqdnName(): boolean {
      return this.fqdnList.some((v) => v.fqdnName);
    },
  },

  methods: {
    /** 変更機能 */
    async submit() {
      await this.$confirm(
        "インターネットサイト設定を変更します。よろしいですか？"
      );
      // 変更データの設定
      const reqData: PostType4InternetSite = {
        addressList:
          this.addressList.length === 1 && !this.addressList[0].ipAddress
            ? []
            : this.addressList.map((e) => ({
                ipAddressId: e.ipAddressId || null,
                ipAddressName: e.ipAddressName || null,
                ipAddress: e.ipAddress,
              })),
        fqdnList:
          this.fqdnList.length === 1 && !this.fqdnList[0].fqdn
            ? []
            : this.fqdnList.map((e) => ({
                fqdnId: e.fqdnId || null,
                fqdnName: e.fqdnName || null,
                fqdn: e.fqdn,
              })),
        type4SiteKeyId: this.internetSite.type4SiteKeyId,
      };
      await this.$api.type4SiteApi.postType4InternetSite(this.type4Id, reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * IPAddress追加機能
     * 押下時一行追加
     */
    addIPAddress(push: (item: any) => void) {
      const addItem = {
        ipAddressId: "",
        ipAddressName: "",
        ipAddress: "",
        isPolicyInUse: false,
      };
      this.addressList.push(addItem);
      push(addItem);
    },
    /**
     * fqdn追加機能
     * 押下時一行追加
     */
    addFqdn(push: (item: any) => void) {
      const addItem = {
        fqdnId: "",
        fqdnName: "",
        fqdn: "",
        isPolicyInUse: false,
      };
      this.fqdnList.push(addItem);
      push(addItem);
    },
    /**
     * IPAddress削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeIPAddress(index: number, remove: (idx: number) => void) {
      if (this.addressList.length > 1) {
        this.addressList.splice(index, 1);
        remove(index);
      } else {
        this.addressList = [
          {
            ipAddressId: "",
            ipAddressName: "",
            ipAddress: "",
            isPolicyInUse: false,
          },
        ];
      }
    },
    /**
     * fqdn削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeFqdn(index: number, remove: (idx: number) => void) {
      if (this.fqdnList.length > 1) {
        this.fqdnList.splice(index, 1);
        remove(index);
      } else {
        this.fqdnList = [
          {
            fqdnId: "",
            fqdnName: "",
            fqdn: "",
            isPolicyInUse: false,
          },
        ];
      }
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-body {
  min-height: 55vh;
}
</style>
